import { HomeChargingSupportingDocumentAPI } from "./homeChargingSupportingDocumentsAPI";

export const fakeHomeChargingSupportingDocumentsByMonth: Record<
  number,
  HomeChargingSupportingDocumentAPI[]
> = {
  7: [
    {
      driverUuid: "c1000000-0000-4000-8000-000000000001",
      firstName: "Camille",
      lastName: "Durand",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-080100000001",
          stopAt: "2026-08-03T06:00:00.000Z",
          closedAt: "2026-08-03T09:00:00.000Z",
          registrationNumber: "AB-112-KL",
          totalEnergy: 18.7,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.74,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080100000002",
          stopAt: "2026-08-07T06:00:00.000Z",
          closedAt: "2026-08-07T09:00:00.000Z",
          registrationNumber: "AB-112-KL",
          totalEnergy: 15.3,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.06,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080100000003",
          stopAt: "2026-08-12T06:00:00.000Z",
          closedAt: "2026-08-12T09:00:00.000Z",
          registrationNumber: "AB-112-KL",
          totalEnergy: 22.1,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.42,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080100000004",
          stopAt: "2026-08-16T06:00:00.000Z",
          closedAt: "2026-08-16T09:00:00.000Z",
          registrationNumber: "AB-112-KL",
          totalEnergy: 17.4,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.48,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080100000005",
          stopAt: "2026-08-20T06:00:00.000Z",
          closedAt: "2026-08-20T09:00:00.000Z",
          registrationNumber: "AB-112-KL",
          totalEnergy: 20,
          ratePerKwh: 0.2,
          reimbursementAmount: 4,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080100000006",
          stopAt: "2026-08-25T06:00:00.000Z",
          closedAt: "2026-08-25T09:00:00.000Z",
          registrationNumber: "AB-112-KL",
          totalEnergy: 16.4,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.28,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080100000007",
          stopAt: "2026-08-29T06:00:00.000Z",
          closedAt: "2026-08-29T09:00:00.000Z",
          registrationNumber: "AB-112-KL",
          totalEnergy: 21.3,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.26,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: {
        createdAt: "2026-09-01T09:00:00.000Z",
        createdBy: { firstName: "Étienne", lastName: "Roussel" },
      },
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000002",
      firstName: "Jerome",
      lastName: "Bell",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-080200000001",
          stopAt: "2026-08-06T06:00:00.000Z",
          closedAt: "2026-08-06T09:00:00.000Z",
          registrationNumber: "FG-245-RT",
          totalEnergy: 21.6,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.32,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080200000002",
          stopAt: "2026-08-16T06:00:00.000Z",
          closedAt: "2026-08-16T09:00:00.000Z",
          registrationNumber: "FG-245-RT",
          totalEnergy: 17.7,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.54,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080200000003",
          stopAt: "2026-08-26T06:00:00.000Z",
          closedAt: "2026-08-26T09:00:00.000Z",
          registrationNumber: "FG-245-RT",
          totalEnergy: 25.5,
          ratePerKwh: 0.2,
          reimbursementAmount: 5.1,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: {
        createdAt: "2026-09-01T09:00:00.000Z",
        createdBy: { firstName: "Étienne", lastName: "Roussel" },
      },
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000003",
      firstName: "Pierre",
      lastName: "Dupont",
      charges: [],
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000004",
      firstName: "Thierry",
      lastName: "Sabard",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-080400000001",
          stopAt: "2026-08-04T06:00:00.000Z",
          closedAt: "2026-08-04T09:00:00.000Z",
          registrationNumber: "KL-529-PM",
          totalEnergy: 17.8,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.56,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080400000002",
          stopAt: "2026-08-12T06:00:00.000Z",
          closedAt: "2026-08-12T09:00:00.000Z",
          registrationNumber: "KL-529-PM",
          totalEnergy: 14.6,
          ratePerKwh: 0.2,
          reimbursementAmount: 2.92,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080400000003",
          stopAt: "2026-08-20T06:00:00.000Z",
          closedAt: "2026-08-20T09:00:00.000Z",
          registrationNumber: "KL-529-PM",
          totalEnergy: 21.1,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.22,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080400000004",
          stopAt: "2026-08-28T06:00:00.000Z",
          closedAt: "2026-08-28T09:00:00.000Z",
          registrationNumber: "KL-529-PM",
          totalEnergy: 16.8,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.36,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: {
        createdAt: "2026-09-02T14:30:00.000Z",
        createdBy: { firstName: "Claire", lastName: "Moreau" },
      },
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000005",
      firstName: "Aude",
      lastName: "Bousquet",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-080500000001",
          stopAt: "2026-08-03T06:00:00.000Z",
          closedAt: "2026-08-03T09:00:00.000Z",
          registrationNumber: "MN-614-QS",
          totalEnergy: 20.2,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.04,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080500000002",
          stopAt: "2026-08-08T06:00:00.000Z",
          closedAt: "2026-08-08T09:00:00.000Z",
          registrationNumber: "MN-614-QS",
          totalEnergy: 16.5,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.3,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080500000003",
          stopAt: "2026-08-13T06:00:00.000Z",
          closedAt: "2026-08-13T09:00:00.000Z",
          registrationNumber: "MN-614-QS",
          totalEnergy: 23.8,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.76,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080500000004",
          stopAt: "2026-08-19T06:00:00.000Z",
          closedAt: "2026-08-19T09:00:00.000Z",
          registrationNumber: "MN-614-QS",
          totalEnergy: 18.8,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.76,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080500000005",
          stopAt: "2026-08-24T06:00:00.000Z",
          closedAt: "2026-08-24T09:00:00.000Z",
          registrationNumber: "MN-614-QS",
          totalEnergy: 21.6,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.32,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080500000006",
          stopAt: "2026-08-29T06:00:00.000Z",
          closedAt: "2026-08-29T09:00:00.000Z",
          registrationNumber: "MN-614-QS",
          totalEnergy: 18,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.6,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: {
        createdAt: "2026-09-02T14:30:00.000Z",
        createdBy: { firstName: "Claire", lastName: "Moreau" },
      },
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000006",
      firstName: "Lucas",
      lastName: "Martin",
      charges: [],
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000007",
      firstName: "Sophie",
      lastName: "Lefèvre",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-080700000001",
          stopAt: "2026-08-02T06:00:00.000Z",
          closedAt: "2026-08-02T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 20.7,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.14,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080700000002",
          stopAt: "2026-08-05T06:00:00.000Z",
          closedAt: "2026-08-05T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 17,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.4,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080700000003",
          stopAt: "2026-08-08T06:00:00.000Z",
          closedAt: "2026-08-08T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 24.5,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.9,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080700000004",
          stopAt: "2026-08-11T06:00:00.000Z",
          closedAt: "2026-08-11T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 19.3,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.86,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080700000005",
          stopAt: "2026-08-14T06:00:00.000Z",
          closedAt: "2026-08-14T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 22.2,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.44,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080700000006",
          stopAt: "2026-08-18T06:00:00.000Z",
          closedAt: "2026-08-18T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 18.2,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.64,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080700000007",
          stopAt: "2026-08-21T06:00:00.000Z",
          closedAt: "2026-08-21T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 23.2,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.64,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080700000008",
          stopAt: "2026-08-24T06:00:00.000Z",
          closedAt: "2026-08-24T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 20.1,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.02,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080700000009",
          stopAt: "2026-08-27T06:00:00.000Z",
          closedAt: "2026-08-27T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 21.4,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.28,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080700000010",
          stopAt: "2026-08-30T06:00:00.000Z",
          closedAt: "2026-08-30T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 19.1,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.82,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: {
        createdAt: "2026-09-04T10:15:00.000Z",
        createdBy: { firstName: "Étienne", lastName: "Roussel" },
      },
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000008",
      firstName: "Léa",
      lastName: "Garnier",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-080800000001",
          stopAt: "2026-08-02T06:00:00.000Z",
          closedAt: "2026-08-02T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 20.1,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.02,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080800000002",
          stopAt: "2026-08-06T06:00:00.000Z",
          closedAt: "2026-08-06T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 16.5,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.3,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080800000003",
          stopAt: "2026-08-10T06:00:00.000Z",
          closedAt: "2026-08-10T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 23.7,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.74,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080800000004",
          stopAt: "2026-08-14T06:00:00.000Z",
          closedAt: "2026-08-14T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 18.7,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.74,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080800000005",
          stopAt: "2026-08-18T06:00:00.000Z",
          closedAt: "2026-08-18T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 21.5,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.3,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080800000006",
          stopAt: "2026-08-22T06:00:00.000Z",
          closedAt: "2026-08-22T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 17.7,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.54,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080800000007",
          stopAt: "2026-08-26T06:00:00.000Z",
          closedAt: "2026-08-26T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 22.5,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.5,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-080800000008",
          stopAt: "2026-08-30T06:00:00.000Z",
          closedAt: "2026-08-30T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 19.7,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.94,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: null,
    },
  ],
  8: [
    {
      driverUuid: "c1000000-0000-4000-8000-000000000001",
      firstName: "Camille",
      lastName: "Durand",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-090100000001",
          stopAt: "2026-08-31T20:00:00.000Z",
          closedAt: "2026-09-01T07:00:00.000Z",
          registrationNumber: "AB-112-KL",
          totalEnergy: 17,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.4,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090100000002",
          stopAt: "2026-09-02T06:00:00.000Z",
          closedAt: "2026-09-02T09:00:00.000Z",
          registrationNumber: "AB-112-KL",
          totalEnergy: 18.4,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.68,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090100000003",
          stopAt: "2026-09-05T06:00:00.000Z",
          closedAt: "2026-09-05T09:00:00.000Z",
          registrationNumber: "AB-112-KL",
          totalEnergy: 22.1,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.42,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090100000004",
          stopAt: "2026-09-09T06:00:00.000Z",
          closedAt: "2026-09-09T09:00:00.000Z",
          registrationNumber: "AB-112-KL",
          totalEnergy: 15.7,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.14,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090100000005",
          stopAt: "2026-09-13T06:00:00.000Z",
          closedAt: "2026-09-13T09:00:00.000Z",
          registrationNumber: "AB-112-KL",
          totalEnergy: 24,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.8,
          excludedAt: "2026-10-01T08:00:00.000Z",
          excludedBy: "a1000000-0000-4000-8000-000000000001",
          exclusionReason: "usage personnel",
        },
        {
          uuid: "e1000000-0000-4000-8000-090100000006",
          stopAt: "2026-09-17T06:00:00.000Z",
          closedAt: "2026-09-17T09:00:00.000Z",
          registrationNumber: "AB-112-KL",
          totalEnergy: 19.3,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.86,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090100000007",
          stopAt: "2026-09-22T06:00:00.000Z",
          closedAt: "2026-09-22T09:00:00.000Z",
          registrationNumber: "EV-418-QC",
          totalEnergy: 21.8,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.36,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090100000008",
          stopAt: "2026-09-26T06:00:00.000Z",
          closedAt: "2026-09-26T09:00:00.000Z",
          registrationNumber: "EV-418-QC",
          totalEnergy: 16.5,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.3,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000002",
      firstName: "Jerome",
      lastName: "Bell",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-090200000001",
          stopAt: "2026-09-08T06:00:00.000Z",
          closedAt: "2026-09-08T09:00:00.000Z",
          registrationNumber: "FG-245-RT",
          totalEnergy: 59.6,
          ratePerKwh: 0.2,
          reimbursementAmount: 11.92,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090200000002",
          stopAt: "2026-09-23T06:00:00.000Z",
          closedAt: "2026-09-23T09:00:00.000Z",
          registrationNumber: "FG-245-RT",
          totalEnergy: 49,
          ratePerKwh: 0.2,
          reimbursementAmount: 9.8,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000003",
      firstName: "Pierre",
      lastName: "Dupont",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-090300000001",
          stopAt: "2026-09-06T06:00:00.000Z",
          closedAt: "2026-09-06T09:00:00.000Z",
          registrationNumber: "HJ-387-NB",
          totalEnergy: 20.3,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.06,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090300000002",
          stopAt: "2026-09-16T06:00:00.000Z",
          closedAt: "2026-09-16T09:00:00.000Z",
          registrationNumber: "HJ-387-NB",
          totalEnergy: 16.6,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.32,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090300000003",
          stopAt: "2026-09-26T06:00:00.000Z",
          closedAt: "2026-09-26T09:00:00.000Z",
          registrationNumber: "HJ-387-NB",
          totalEnergy: 24.1,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.82,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000004",
      firstName: "Thierry",
      lastName: "Sabard",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-090400000001",
          stopAt: "2026-09-06T06:00:00.000Z",
          closedAt: "2026-09-06T09:00:00.000Z",
          registrationNumber: "KL-529-PM",
          totalEnergy: 17.6,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.52,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090400000002",
          stopAt: "2026-09-16T06:00:00.000Z",
          closedAt: "2026-09-16T09:00:00.000Z",
          registrationNumber: "KL-529-PM",
          totalEnergy: 14.4,
          ratePerKwh: 0.2,
          reimbursementAmount: 2.88,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090400000003",
          stopAt: "2026-09-26T06:00:00.000Z",
          closedAt: "2026-09-26T09:00:00.000Z",
          registrationNumber: "KL-529-PM",
          totalEnergy: 20.9,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.18,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000005",
      firstName: "Aude",
      lastName: "Bousquet",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-090500000001",
          stopAt: "2026-09-04T06:00:00.000Z",
          closedAt: "2026-09-04T09:00:00.000Z",
          registrationNumber: "MN-614-QS",
          totalEnergy: 19.2,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.84,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090500000002",
          stopAt: "2026-09-10T06:00:00.000Z",
          closedAt: "2026-09-10T09:00:00.000Z",
          registrationNumber: "MN-614-QS",
          totalEnergy: 15.8,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.16,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090500000003",
          stopAt: "2026-09-16T06:00:00.000Z",
          closedAt: "2026-09-16T09:00:00.000Z",
          registrationNumber: "MN-614-QS",
          totalEnergy: 22.7,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.54,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090500000004",
          stopAt: "2026-09-22T06:00:00.000Z",
          closedAt: "2026-09-22T09:00:00.000Z",
          registrationNumber: "MN-614-QS",
          totalEnergy: 17.9,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.58,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090500000005",
          stopAt: "2026-09-28T06:00:00.000Z",
          closedAt: "2026-09-28T09:00:00.000Z",
          registrationNumber: "MN-614-QS",
          totalEnergy: 20.8,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.16,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: {
        createdAt: "2026-10-02T08:00:00.000Z",
        createdBy: { firstName: "Étienne", lastName: "Roussel" },
      },
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000006",
      firstName: "Lucas",
      lastName: "Martin",
      charges: [],
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000007",
      firstName: "Sophie",
      lastName: "Lefèvre",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-090700000001",
          stopAt: "2026-09-02T06:00:00.000Z",
          closedAt: "2026-09-02T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 20.7,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.14,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090700000002",
          stopAt: "2026-09-04T06:00:00.000Z",
          closedAt: "2026-09-04T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 17,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.4,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090700000003",
          stopAt: "2026-09-07T06:00:00.000Z",
          closedAt: "2026-09-07T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 24.5,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.9,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090700000004",
          stopAt: "2026-09-09T06:00:00.000Z",
          closedAt: "2026-09-09T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 19.3,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.86,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090700000005",
          stopAt: "2026-09-12T06:00:00.000Z",
          closedAt: "2026-09-12T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 22.2,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.44,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090700000006",
          stopAt: "2026-09-14T06:00:00.000Z",
          closedAt: "2026-09-14T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 18.2,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.64,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090700000007",
          stopAt: "2026-09-17T06:00:00.000Z",
          closedAt: "2026-09-17T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 23.2,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.64,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090700000008",
          stopAt: "2026-09-19T06:00:00.000Z",
          closedAt: "2026-09-19T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 20.1,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.02,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090700000009",
          stopAt: "2026-09-22T06:00:00.000Z",
          closedAt: "2026-09-22T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 21.4,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.28,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090700000010",
          stopAt: "2026-09-24T06:00:00.000Z",
          closedAt: "2026-09-24T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 18.7,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.74,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090700000011",
          stopAt: "2026-09-27T06:00:00.000Z",
          closedAt: "2026-09-27T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 22.8,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.56,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090700000012",
          stopAt: "2026-09-29T06:00:00.000Z",
          closedAt: "2026-09-29T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 20.2,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.04,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: {
        createdAt: "2026-10-01T15:20:00.000Z",
        createdBy: { firstName: "Claire", lastName: "Moreau" },
      },
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000009",
      firstName: "Mohamed",
      lastName: "Benali",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-090900000001",
          stopAt: "2026-09-16T06:00:00.000Z",
          closedAt: "2026-09-16T09:00:00.000Z",
          registrationNumber: "UV-963-YZ",
          totalEnergy: 7.4,
          ratePerKwh: 0.2,
          reimbursementAmount: 1.48,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000010",
      firstName: "Inès",
      lastName: "Rousseau-Lambert",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-091000000001",
          stopAt: "2026-09-03T06:00:00.000Z",
          closedAt: "2026-09-03T09:00:00.000Z",
          registrationNumber: "WX-174-AB",
          totalEnergy: 22.5,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.5,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-091000000002",
          stopAt: "2026-09-08T06:00:00.000Z",
          closedAt: "2026-09-08T09:00:00.000Z",
          registrationNumber: "WX-174-AB",
          totalEnergy: 18.4,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.68,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-091000000003",
          stopAt: "2026-09-13T06:00:00.000Z",
          closedAt: "2026-09-13T09:00:00.000Z",
          registrationNumber: "WX-174-AB",
          totalEnergy: 26.5,
          ratePerKwh: 0.2,
          reimbursementAmount: 5.3,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-091000000004",
          stopAt: "2026-09-18T06:00:00.000Z",
          closedAt: "2026-09-18T09:00:00.000Z",
          registrationNumber: "WX-174-AB",
          totalEnergy: 20.9,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.18,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-091000000005",
          stopAt: "2026-09-23T06:00:00.000Z",
          closedAt: "2026-09-23T09:00:00.000Z",
          registrationNumber: "WX-174-AB",
          totalEnergy: 24.1,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.82,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-091000000006",
          stopAt: "2026-09-28T06:00:00.000Z",
          closedAt: "2026-09-28T09:00:00.000Z",
          registrationNumber: "WX-174-AB",
          totalEnergy: 20.1,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.02,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: {
        createdAt: "2026-10-03T09:45:00.000Z",
        createdBy: { firstName: "Étienne", lastName: "Roussel" },
      },
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000011",
      firstName: "Hugo",
      lastName: "Fontaine",
      charges: [],
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000008",
      firstName: "Léa",
      lastName: "Garnier",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-090800000001",
          stopAt: "2026-09-02T06:00:00.000Z",
          closedAt: "2026-09-02T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 20.7,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.14,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090800000002",
          stopAt: "2026-09-06T06:00:00.000Z",
          closedAt: "2026-09-06T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 17,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.4,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090800000003",
          stopAt: "2026-09-09T06:00:00.000Z",
          closedAt: "2026-09-09T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 24.5,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.9,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090800000004",
          stopAt: "2026-09-12T06:00:00.000Z",
          closedAt: "2026-09-12T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 19.3,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.86,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090800000005",
          stopAt: "2026-09-16T06:00:00.000Z",
          closedAt: "2026-09-16T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 22.2,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.44,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090800000006",
          stopAt: "2026-09-19T06:00:00.000Z",
          closedAt: "2026-09-19T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 18.2,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.64,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090800000007",
          stopAt: "2026-09-22T06:00:00.000Z",
          closedAt: "2026-09-22T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 23.2,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.64,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090800000008",
          stopAt: "2026-09-26T06:00:00.000Z",
          closedAt: "2026-09-26T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 20.1,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.02,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-090800000009",
          stopAt: "2026-09-29T06:00:00.000Z",
          closedAt: "2026-09-29T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 21.9,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.38,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000012",
      firstName: "Nathalie",
      lastName: "Chevalier",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-091200000001",
          stopAt: "2026-09-04T06:00:00.000Z",
          closedAt: "2026-09-04T09:00:00.000Z",
          registrationNumber: "YZ-285-CD",
          totalEnergy: 18.6,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.72,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-091200000002",
          stopAt: "2026-09-12T06:00:00.000Z",
          closedAt: "2026-09-12T09:00:00.000Z",
          registrationNumber: "YZ-285-CD",
          totalEnergy: 15.2,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.04,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-091200000003",
          stopAt: "2026-09-19T06:00:00.000Z",
          closedAt: "2026-09-19T09:00:00.000Z",
          registrationNumber: "YZ-285-CD",
          totalEnergy: 21.9,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.38,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-091200000004",
          stopAt: "2026-09-27T06:00:00.000Z",
          closedAt: "2026-09-27T09:00:00.000Z",
          registrationNumber: "YZ-285-CD",
          totalEnergy: 17.5,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.5,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: {
        createdAt: "2026-10-05T16:10:00.000Z",
        createdBy: null,
      },
    },
  ],
  9: [
    {
      driverUuid: "c1000000-0000-4000-8000-000000000001",
      firstName: "Camille",
      lastName: "Durand",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-100100000001",
          stopAt: "2026-10-04T06:00:00.000Z",
          closedAt: "2026-10-04T09:00:00.000Z",
          registrationNumber: "AB-112-KL",
          totalEnergy: 19.4,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.88,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-100100000002",
          stopAt: "2026-10-10T06:00:00.000Z",
          closedAt: "2026-10-10T09:00:00.000Z",
          registrationNumber: "AB-112-KL",
          totalEnergy: 15.9,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.18,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-100100000003",
          stopAt: "2026-10-16T06:00:00.000Z",
          closedAt: "2026-10-16T09:00:00.000Z",
          registrationNumber: "AB-112-KL",
          totalEnergy: 22.9,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.58,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000002",
      firstName: "Jerome",
      lastName: "Bell",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-100200000001",
          stopAt: "2026-10-10T06:00:00.000Z",
          closedAt: "2026-10-10T09:00:00.000Z",
          registrationNumber: "FG-245-RT",
          totalEnergy: 22.4,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.48,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000003",
      firstName: "Pierre",
      lastName: "Dupont",
      charges: [],
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000004",
      firstName: "Thierry",
      lastName: "Sabard",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-100400000001",
          stopAt: "2026-10-05T06:00:00.000Z",
          closedAt: "2026-10-05T09:00:00.000Z",
          registrationNumber: "KL-529-PM",
          totalEnergy: 17.3,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.46,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-100400000002",
          stopAt: "2026-10-15T06:00:00.000Z",
          closedAt: "2026-10-15T09:00:00.000Z",
          registrationNumber: "KL-529-PM",
          totalEnergy: 14.2,
          ratePerKwh: 0.2,
          reimbursementAmount: 2.84,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000005",
      firstName: "Aude",
      lastName: "Bousquet",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-100500000001",
          stopAt: "2026-10-05T06:00:00.000Z",
          closedAt: "2026-10-05T09:00:00.000Z",
          registrationNumber: "MN-614-QS",
          totalEnergy: 22,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.4,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-100500000002",
          stopAt: "2026-10-15T06:00:00.000Z",
          closedAt: "2026-10-15T09:00:00.000Z",
          registrationNumber: "MN-614-QS",
          totalEnergy: 18.1,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.62,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000007",
      firstName: "Sophie",
      lastName: "Lefèvre",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-100700000001",
          stopAt: "2026-10-02T06:00:00.000Z",
          closedAt: "2026-10-02T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 20.5,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.1,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-100700000002",
          stopAt: "2026-10-06T06:00:00.000Z",
          closedAt: "2026-10-06T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 16.8,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.36,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-100700000003",
          stopAt: "2026-10-10T06:00:00.000Z",
          closedAt: "2026-10-10T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 24.2,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.84,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-100700000004",
          stopAt: "2026-10-14T06:00:00.000Z",
          closedAt: "2026-10-14T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 19,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.8,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-100700000005",
          stopAt: "2026-10-18T06:00:00.000Z",
          closedAt: "2026-10-18T09:00:00.000Z",
          registrationNumber: "PR-736-TV",
          totalEnergy: 22.1,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.42,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000009",
      firstName: "Mohamed",
      lastName: "Benali",
      charges: [],
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000010",
      firstName: "Inès",
      lastName: "Rousseau-Lambert",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-101000000001",
          stopAt: "2026-10-04T06:00:00.000Z",
          closedAt: "2026-10-04T09:00:00.000Z",
          registrationNumber: "WX-174-AB",
          totalEnergy: 20.5,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.1,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-101000000002",
          stopAt: "2026-10-10T06:00:00.000Z",
          closedAt: "2026-10-10T09:00:00.000Z",
          registrationNumber: "WX-174-AB",
          totalEnergy: 16.8,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.36,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-101000000003",
          stopAt: "2026-10-16T06:00:00.000Z",
          closedAt: "2026-10-16T09:00:00.000Z",
          registrationNumber: "WX-174-AB",
          totalEnergy: 24.4,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.88,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000008",
      firstName: "Léa",
      lastName: "Garnier",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-100800000001",
          stopAt: "2026-10-03T06:00:00.000Z",
          closedAt: "2026-10-03T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 20.1,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.02,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-100800000002",
          stopAt: "2026-10-08T06:00:00.000Z",
          closedAt: "2026-10-08T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 16.5,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.3,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-100800000003",
          stopAt: "2026-10-12T06:00:00.000Z",
          closedAt: "2026-10-12T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 23.8,
          ratePerKwh: 0.2,
          reimbursementAmount: 4.76,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
        {
          uuid: "e1000000-0000-4000-8000-100800000004",
          stopAt: "2026-10-17T06:00:00.000Z",
          closedAt: "2026-10-17T09:00:00.000Z",
          registrationNumber: "ST-852-WX",
          totalEnergy: 18.9,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.78,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000012",
      firstName: "Nathalie",
      lastName: "Chevalier",
      charges: [
        {
          uuid: "e1000000-0000-4000-8000-101200000001",
          stopAt: "2026-10-10T06:00:00.000Z",
          closedAt: "2026-10-10T09:00:00.000Z",
          registrationNumber: "YZ-285-CD",
          totalEnergy: 18.9,
          ratePerKwh: 0.2,
          reimbursementAmount: 3.78,
          excludedAt: null,
          excludedBy: null,
          exclusionReason: null,
        },
      ],
      supportingDocument: null,
    },
  ],
};
